import {
  Categories,
  Maybe,
  OfferDetailsRoomOffer,
  RoomOffers,
} from '~/domains/graphql';

import { BookingRateFilter } from '../enums';

export const isPromotionalOffer = (category: Maybe<Categories>) =>
  category?.code &&
  [BookingRateFilter.OnlyOn].includes(
    category.code.toUpperCase() as BookingRateFilter,
  );

export const isPromotionOffer = (category: Maybe<Categories>) => {
  if (!category?.code) {
    return false;
  }

  return category.code
    .toUpperCase()
    .split(',')
    .includes(BookingRateFilter.Promotion);
};

export const isPublicOffer = (category: Maybe<Categories>) => {
  if (!category?.code) {
    return false;
  }

  const codes = category.code.toUpperCase().split(',');

  const hasPreferred = codes.includes(BookingRateFilter.Preferred);
  const hasStandard = codes.includes(BookingRateFilter.Standard);

  return (hasPreferred && !hasStandard) || hasStandard;
};

export const isPublicOrLoyaltyOffer = (category: Maybe<Categories>) =>
  category?.code &&
  [
    BookingRateFilter.Standard,
    BookingRateFilter.Loyalty,
    BookingRateFilter.Preferred,
    BookingRateFilter.Promotion,
  ].includes(category.code.toUpperCase() as BookingRateFilter);

export const isPreferredOffer = (category: Maybe<Categories>) =>
  category?.code &&
  [BookingRateFilter.Preferred].includes(
    category.code.toUpperCase() as BookingRateFilter,
  );

// Type guard function
export const isRoomOffers = (
  obj: RoomOffers | OfferDetailsRoomOffer,
): obj is RoomOffers => '__typename' in obj && obj.__typename === 'RoomOffers';
export const isOfferDetailsRoomOffer = (
  obj: RoomOffers | OfferDetailsRoomOffer,
): obj is OfferDetailsRoomOffer =>
  '__typename' in obj && obj.__typename === 'OfferDetailsRoomOffer';

export const publicOrLoyaltyOffers = (
  offers: Array<RoomOffers | OfferDetailsRoomOffer>,
) =>
  offers
    .filter(offer => offer?.categories?.some(isPublicOrLoyaltyOffer))
    .filter(
      offer =>
        !offer.categories?.find(
          category => category?.code === BookingRateFilter.OnlyOn,
        ),
    );
